/* Syrup Oracle: product-mention auto-linker.
   Links mentions of BG Reynolds products to their product pages inside
   content areas (.rte, recipe cards, the Oracle's dealt card).

   Conservative matching to avoid false positives ("Demerara rum" must NOT
   link to the Demerara syrup):
   1. Exact product titles, case-insensitive.
   2. "BG Reynolds <core>" phrases, where <core> is the product title minus
      generic words (Cocktail, Syrup, Tropical, Original, Mix, Mixer...).
   The current product is skipped on its own page. Existing links, buttons,
   scripts, and form fields are never touched. */
(function () {
  'use strict';

  var GENERIC = ['cocktail', 'syrup', 'syrups', 'tropical', 'original', 'mix', 'mixer', 'bg', 'reynolds', 'the', '|', '-', '(pre-sale)', 'pre-sale'];
  // Short names recipes use that don't match the full product title's core
  // (e.g. "BG Reynolds Fassionola" vs product "Red Fassionola"). handle -> extra
  // core aliases; the "BG Reynolds <alias>" form is added so bare generic words
  // (Vanilla, Ginger) never false-positive without the brand prefix.
  var ALIASES = {
    'red-fassionola': ['Fassionola'],
    'divine-vanilla': ['Vanilla'],
    'wild-ginger': ['Ginger']
  };
  var CONTAINERS = '.rte, .so-recipe__ingredients, .so-recipe__method, .product-description, .so-short-desc, .syrup-oracle .ingredients, .syrup-oracle .method, .homepage-blog--excerpt, .article__body';
  var SKIP_CLOSEST = 'a, button, script, style, input, textarea, select, h1, .so-eyebrow';

  function escapeRe(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function coreOf(title) {
    var words = title.split(/\s+/).filter(function (wd) {
      return GENERIC.indexOf(wd.toLowerCase().replace(/[^a-z\-()']/g, '')) === -1 && wd.trim() !== '';
    });
    return words.join(' ').trim();
  }

  function currentProductHandle() {
    var m = location.pathname.match(/\/products\/([a-z0-9\-]+)/);
    return m ? m[1] : null;
  }

  // Full active-recipe name list beats the 50-entry Liquid cap on
  // shop.metaobjects: session cache -> bar-book.json (dashboard-regenerated
  // Shopify File) -> the Liquid-rendered #so-drink-map (first 50) as fallback.
  var BB_DATA_URL = 'https://cdn.shopify.com/s/files/1/0018/5715/9281/files/bar-book.json';

  function getDrinkNames() {
    try {
      var c = JSON.parse(sessionStorage.getItem('so-bb-names-v1'));
      if (c && c.names && c.names.length && (Date.now() - c.t) < 3600 * 1000) return Promise.resolve(c.names);
    } catch (e) {}
    var cb = Math.floor(Date.now() / 600000); // 10-min bucket; MUST be ?v= — the Files CDN keys cache on v only
    return fetch(BB_DATA_URL + (BB_DATA_URL.indexOf('?') !== -1 ? '&' : '?') + 'v=' + cb)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (doc) {
        var names = (doc.recipes || []).map(function (rec) { return rec.title; }).filter(Boolean);
        if (!names.length) throw new Error('empty');
        try { sessionStorage.setItem('so-bb-names-v1', JSON.stringify({ t: Date.now(), names: names })); } catch (e) {}
        return names;
      })
      .catch(function () {
        var el = document.getElementById('so-drink-map');
        if (!el) return [];
        try { return JSON.parse(el.textContent); } catch (e) { return []; }
      });
  }

  Promise.all([
    fetch('/products.json?limit=250').then(function (r) { return r.json(); }),
    getDrinkNames()
  ])
    .then(function (res) {
      var data = res[0];
      var drinkNames = res[1];
      var self = currentProductHandle();
      var patterns = [];
      (data.products || []).forEach(function (p) {
        if (p.handle === self) return;
        var url = '/products/' + p.handle;
        patterns.push({ text: p.title, url: url });
        var core = coreOf(p.title);
        if (core && core.length > 2) {
          patterns.push({ text: 'BG Reynolds ' + core, url: url });
        }
        (ALIASES[p.handle] || []).forEach(function (al) {
          patterns.push({ text: 'BG Reynolds ' + al, url: url });
        });
      });
      // Bar Book drink names (active recipes only — draft recipes never make
      // it into bar-book.json or the Liquid map). Longest-first sort below
      // keeps product titles ("Mai Tai Cocktail Mix") winning over drink
      // names ("Mai Tai") on overlap.
      (drinkNames || []).forEach(function (name) {
        if (!name || name.length < 4) return;
        var slug = name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        patterns.push({ text: name, url: '/pages/the-bar-book#recipe-' + slug });
      });
      if (!patterns.length) return;

      // longest first so "BG Reynolds Hibiscus Grenadine" beats "BG Reynolds Hibiscus"
      patterns.sort(function (a, b) { return b.text.length - a.text.length; });
      var byLower = {};
      patterns.forEach(function (p) {
        var k = p.text.toLowerCase();
        if (!byLower[k]) byLower[k] = p.url;
      });
      var re = new RegExp('(' + patterns.map(function (p) { return escapeRe(p.text); }).join('|') + ')', 'gi');

      function linkify(root) {
        var containers = root.matches && root.matches(CONTAINERS) ? [root] : root.querySelectorAll(CONTAINERS);
        Array.prototype.forEach.call(containers, function (el) {
          var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
            acceptNode: function (node) {
              if (!node.nodeValue || node.nodeValue.length < 4) return NodeFilter.FILTER_REJECT;
              if (node.parentElement && node.parentElement.closest(SKIP_CLOSEST)) return NodeFilter.FILTER_REJECT;
              return NodeFilter.FILTER_ACCEPT;
            }
          });
          var nodes = [];
          while (walker.nextNode()) nodes.push(walker.currentNode);
          nodes.forEach(function (node) {
            var text = node.nodeValue;
            re.lastIndex = 0;
            if (!re.test(text)) return;
            re.lastIndex = 0;
            var frag = document.createDocumentFragment();
            var last = 0, m;
            while ((m = re.exec(text)) !== null) {
              var url = byLower[m[1].toLowerCase()];
              if (!url) continue;
              // no self-links: a drink name inside its own Bar Book card stays text
              if (url.indexOf('#') !== -1) {
                var card = node.parentElement && node.parentElement.closest('.so-recipe');
                if (card && card.id && url.slice(url.indexOf('#') + 1) === card.id) continue;
              }
              frag.appendChild(document.createTextNode(text.slice(last, m.index)));
              var a = document.createElement('a');
              a.className = 'so-product-link';
              a.href = url;
              a.textContent = m[1];
              frag.appendChild(a);
              last = m.index + m[1].length;
            }
            frag.appendChild(document.createTextNode(text.slice(last)));
            node.parentNode.replaceChild(frag, node);
          });
        });
      }

      var run = function () { linkify(document.body); };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
      } else {
        run();
      }

      // The Oracle deals cards dynamically — relink when its list changes
      var oracle = document.querySelector('.syrup-oracle');
      if (oracle && window.MutationObserver) {
        var pending = null;
        new MutationObserver(function () {
          clearTimeout(pending);
          pending = setTimeout(function () { linkify(oracle); }, 120);
        }).observe(oracle, { childList: true, subtree: true });
      }
    })
    .catch(function () { /* linkifier is progressive enhancement only */ });
})();

/* Rum-guide deep-linker: link the FIRST rum-category phrase in a prose block
   to its Rum Guide anchor (#gold, #dark, #funk…). One link per container to
   stay low-key. Runs on descriptions, the Oracle, and articles — deliberately
   NOT on Bar Book recipe cards (those stay clean; the Bar Book has its own
   page-level link). Independent of the product fetch above. */
(function () {
  'use strict';
  if (location.pathname.indexOf('/pages/rum-guide') !== -1) return; // no self-links
  var CONTAINERS = '.rte, .product-description, .so-short-desc, .article__body, .homepage-blog--excerpt, .syrup-oracle .ingredients, .syrup-oracle .method';
  var SKIP = 'a, button, script, style, input, textarea, select, h1, h2, .so-eyebrow, .so-rum-link';
  var RE = /(pot-?still jamaican|funky jamaican|overproof jamaican|jamaican funk|aged jamaican|jamaican rum|demerara rum|rhum agricole|martinique rhum|agricole|gold rum|white rum|light rum|silver rum|dark rum|blackstrap|spiced rum|overproof rum|151(?:-proof)?)/i;
  function anchorFor(s) {
    s = s.toLowerCase();
    if (/funk|pot-?still jamaican|overproof jamaican/.test(s)) return 'funk';
    if (/jamaican/.test(s)) return 'jamaican';
    if (/demerara/.test(s)) return 'demerara';
    if (/agricole|martinique/.test(s)) return 'agricole';
    if (/gold/.test(s)) return 'gold';
    if (/white|light|silver/.test(s)) return 'white';
    if (/blackstrap|dark/.test(s)) return 'dark';
    if (/spiced/.test(s)) return 'spiced';
    if (/151|overproof/.test(s)) return 'overproof';
    return null;
  }
  function linkOne(el) {
    if (el.getAttribute('data-so-rumlinked')) return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.length < 4) return NodeFilter.FILTER_REJECT;
        if (n.parentElement && n.parentElement.closest(SKIP)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var node;
    while ((node = walker.nextNode())) {
      var m = RE.exec(node.nodeValue);
      if (!m) continue;
      var anchor = anchorFor(m[1]);
      if (!anchor) continue;
      var frag = document.createDocumentFragment();
      frag.appendChild(document.createTextNode(node.nodeValue.slice(0, m.index)));
      var a = document.createElement('a');
      a.className = 'so-rum-link';
      a.href = '/pages/rum-guide#' + anchor;
      a.textContent = m[1];
      frag.appendChild(a);
      frag.appendChild(document.createTextNode(node.nodeValue.slice(m.index + m[1].length)));
      node.parentNode.replaceChild(frag, node);
      el.setAttribute('data-so-rumlinked', '1');
      return;
    }
  }
  function run(root) {
    var cs = (root.matches && root.matches(CONTAINERS)) ? [root] : root.querySelectorAll(CONTAINERS);
    Array.prototype.forEach.call(cs, linkOne);
  }
  var boot = function () { run(document.body); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  var oracle = document.querySelector('.syrup-oracle');
  if (oracle && window.MutationObserver) {
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { run(oracle); }, 140); }).observe(oracle, { childList: true, subtree: true });
  }
})();
